
  import Component from 'vue-class-component'
  import { Prop, Watch } from 'vue-property-decorator'
  import dayjs from 'dayjs'
  import { DetailByExecutive } from './detailByExecutive'
  import ExecutiveDetail from './Detail/ExecutiveDetail.vue'

@Component({
  components: {
    ExecutiveDetail,
  },
})
  export default class PurchasesByExecutive extends DetailByExecutive {
  @Prop() purchases: Record<string, any>
  @Prop() purchasesTarget: Record<string, any>

  amount = 0
  target = 10
  cars = []
  executives = []

  // Methods
  mounted () {
    this.getData()
  }

  getData () {
    if (
      !this.purchases?.sales_stock_view_aggregate ||
      !this.purchasesTarget?.settings_process) return
    const purchasesNumber = this.purchases.sales_stock_view_aggregate?.aggregate?.count
    if (purchasesNumber !== undefined) {
      this.amount = purchasesNumber
    }
    const cars = this.purchases?.sales_stock_view_aggregate?.nodes
    if (cars) {
      this.cars = [...cars].sort((prev, next) => {
        return -dayjs(prev.sold_date).diff(dayjs(next.sold_date))
      })
    }
    const purchasesTarget = this.purchasesTarget?.settings_process?.[0]?.config?.projectedUtility?.quantity
    if (purchasesTarget) {
      this.target = purchasesTarget
    }

    let executives = []
    if (cars) {
      cars.map(car => {
        let executive = car.executive?.person
        if (!executive) {
          executive = {
            first_name: 'Sin',
            surname: 'ejecutivo',
          }
        }
        const newExecutive = `${executive.first_name} ${executive.surname}`
        if (!executives.includes(newExecutive)) {
          executives.push(newExecutive)
        }
      })
    }

    const lowercasedExecutives = executives.map(executive => executive.toLowerCase())
    const lowercasedStaff = this.staffExecutives?.map(executive =>
      `${executive.first_name} ${executive.surname}`.toLowerCase()
    )
    if (this.staffExecutives) {
      this.staffExecutives.forEach(executive => {
        const executiveName = `${executive.first_name} ${executive.surname}`.toLowerCase()
        if (!lowercasedExecutives.includes(executiveName)) {
          executives.push(`${executive.first_name} ${executive.surname}`)
        }
      })
    }

    this.executives = []
    executives = executives.sort()
    if (lowercasedStaff) {
      executives = executives.sort((prev, next) => {
        if (lowercasedStaff.includes(prev.toLowerCase())) {
          if (lowercasedStaff.includes(next.toLowerCase())) {
            return 1
          } else {
            return -1
          }
        } else {
          return 1
        }
      })
    }

    executives.forEach(executive => {
      const filtered = cars.filter(car => {
        let executiveName = ''
        const personExecutive = car.executive?.person
        if (personExecutive === undefined) {
          executiveName = 'Sin ejecutivo'
        } else {
          executiveName = `${personExecutive.first_name} ${personExecutive.surname}`
        }
        return executiveName === executive
      })

      this.executives.push({
        name: executive,
        amount: filtered.length,
      })
    })
  }

  @Watch('purchases', { immediate: true, deep: true })
  @Watch('purchasesTarget', { immediate: true, deep: true })
  @Watch('staffExecutives', { immediate: true, deep: true })
  onDatesChange () {
    this.display = false
    this.getData()
    this.display = true
  }
  }
